
// import { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { getBotInfo } from "./services/botService";
// import BotLoadingMessage from "./components/BotLoadingMessage";
// import { useDispatch, useSelector } from "react-redux";
// import ClientDashboard from "units/client/component/ClientDashboard";
// import { getUserType } from "units/dashboard/services/getUserProfile";
// import { setUser } from "units/dashboard/store/userSlice";

// const Bot = () => {
//     const [logo, setLogo] = useState("");
//     const [status, setStatus] = useState(null);
//     const [web, setWeb] = useState("");
//     const [ownerId, setOwnerId] = useState("");
//     const [userId, setUserId] = useState("");
//     const { username } = useParams();
//     const navigate = useNavigate();
//     const dispatch=useDispatch()
//     const accessToken = useSelector((state) => state.auth.accessToken);
//     console.log(accessToken,"accessTocken")
// console.log(ownerId,userId,"ownerId,userId")
//     useEffect(() => {
//         if (!accessToken || !username) return;
    
//         const fetchBotInfo = async () => {
//             try {
//                 const res = await getBotInfo(username);
//                 if (res?.ok) {
//                     console.log(res.data, "resfetch");
//                     setLogo(res.data.logo);
//                     setStatus(res.data.status || "unknown");
//                     setWeb(res.data.website);
//                     setOwnerId(res.data.ownerId);  
//                 }
//             } catch (error) {
//                 console.error("Error fetching bot info:", error);
//             }
//         };
    
//         fetchBotInfo();
//     }, [accessToken, username]); 
    
//     useEffect(() => {
//         if (!accessToken) return;
    
//         const fetchUser = async () => {
//             try {
//                 const res = await getUserType(accessToken);
//                 if (res?.ok && res?.data) {
//                     console.log(res.data, "user data");
//                     dispatch(setUser(res.data))
//                     setUserId(res?.data?.id); 
//                 }
//             } catch (error) {
//                 console.error("خطا در دریافت اطلاعات کاربر:", error);
//             }
//         };
    
//         fetchUser();
//     }, [accessToken]);
    
//     console.log(ownerId,userId,"ownerId,userId")
//     const renderContent = (username) => {
//         console.log("Current status:", status);
//         if (userId == ownerId && status!="empty") {
//             navigate(`/bot/chatbox/${username}`);
//             return <ClientDashboard />;
//         } else {
//             if (status === null) {
//                 return <div>در حال دریافت اطلاعات...</div>;
//             }
//             if (status === "accepted") {
//                 navigate(`/bot/chatbox/${username}`);
//                 return <ClientDashboard />;
//             }
//             return <BotLoadingMessage />;
//         }
//     };

//     return <>{renderContent(username)}</>;
// };

// export default Bot;

import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getBotInfo } from "./services/botService";
import BotLoadingMessage from "./components/BotLoadingMessage";
import { useDispatch, useSelector } from "react-redux";
import ClientDashboard from "units/client/component/ClientDashboard";
import { getUserType } from "units/dashboard/services/getUserProfile";
import { setUser } from "units/dashboard/store/userSlice";
import { setBotInfo } from "units/client/store/botSlice";

const Bot = () => {
    const [logo, setLogo] = useState("");
    const [status, setStatus] = useState(null);
    const [web, setWeb] = useState("");
    const [ownerId, setOwnerId] = useState(null); 
    const [userId, setUserId] = useState(null);   
    const { username } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const accessToken = useSelector((state) => state.auth.accessToken);


    useEffect(() => {
        if (!accessToken || !username) return;

        const fetchBotInfo = async () => {
            try {
                const res = await getBotInfo(username);
                if (res?.ok) {
                    setLogo(res.data.logo);
                    setStatus(res.data.status || "unknown");
                    setWeb(res.data.website);
                    setOwnerId(res.data.ownerId);
                    dispatch(setBotInfo({name:res?.data?.name,username:""}))
                }
            } catch (error) {
                console.error("Error fetching bot info:", error);
            }
        };

        fetchBotInfo();
    }, [accessToken, username]);

    useEffect(() => {
        if (!accessToken) return;

        const fetchUser = async () => {
            try {
                const res = await getUserType(accessToken);
                if (res?.ok && res?.data) {
                    dispatch(setUser(res.data));
                    setUserId(res?.data?.id);
                }
            } catch (error) {
                console.error("خطا در دریافت اطلاعات کاربر:", error);
            }
        };

        fetchUser();
    }, [accessToken]);
    useEffect(() => {
        if (ownerId && userId) {
            if (userId === ownerId && status !== "empty") {
                navigate(`/bot/chatbox/${username}`);
            } else if (status === "accepted") {
                navigate(`/bot/chatbox/${username}`);
            }
        }
    }, [ownerId, userId, status, navigate, username]);

    const renderContent = () => {
        if (status === null) {
            return <div>در حال دریافت اطلاعات...</div>;
        }
        return <BotLoadingMessage />;
    };

    return <>{renderContent()}</>;
};

export default Bot;
